module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av311-ba3916a717f8474a16907b4689efc692.jpg";